export default __webpack_public_path__ + "static/media/video_section3.9c048474.mp4";